import {
  checkForUpdates,
  fetchLiveFloorViewerFilters,
  prepareFilter,
} from "@actions";
import { showSiteDetailsModal } from "@actions/modals";
import livefloorview from "@api/livefloorview";
import DownloadButton from "@buttons/DownloadButton";
import OrgTreeButton from "@buttons/OrgTreeButton";
import RefreshButton from "@buttons/RefreshButton";
import { defaultGrid } from "@helpers/datagrid";
import { handleDownload } from "@helpers/downloads";
import DataGrid from "@shared/DataGrid";
import DetailsButton from "@shared/DetailsButton";
import React from "react";
import { connect } from "react-redux";
import { Form, Grid, Select } from "semantic-ui-react";

class SiteDetailsTab extends React.Component {
  state = {
    selectedDetailOption: 0,
    selectedPeriodId: 1,
    selectedPeriodText: "Current Collection Week",
    activeRow: null,
    grid: defaultGrid,
    loading: false,
    detailsLoading: false,
  };

  componentDidUpdate(prevProps) {
    if (!checkForUpdates(prevProps.filters, this.props.filters)) {
      return;
    }

    this.handleRefresh();
  }

  handleRefresh = (callback = () => {}) => {
    const { filterSelected, filterData } = this.props.filters;
    const { operator, company, subcompany, site } = filterSelected;
    const { selectedDetailOption, selectedPeriodId } = this.state;

    this.setState({ loading: true }, () => {
      const fn =
        selectedDetailOption === 0
          ? livefloorview.getCashInBoxGrid
          : livefloorview.getPerformanceGrid;
      fn({
        OperatorId: operator,
        CompanyId: company.id,
        SubCompanyId: subcompany.id,
        SiteId: site.id,
        Manufacturers: prepareFilter(
          filterSelected.manufacturer,
          filterData.manufacturer,
        ),
        GameNames: prepareFilter(filterSelected.game, filterData.game),
        Categories: prepareFilter(
          filterSelected.machinetypes,
          filterData.machinetypes,
        ),
        OperatorRegions: prepareFilter(
          filterSelected.regions,
          filterData.regions,
        ),
        PeriodId: selectedPeriodId,
      }).then(
        (grid) =>
          this.setState({ activeRow: null, grid, loading: false }, () =>
            callback(),
          ),
        () => this.setState({ loading: false }),
      );
    });
  };

  onDetailsClick = () => {
    const { selectedDetailOption } = this.state;
    const { siteId } = this.state.activeRow;
    const isCashInBox = selectedDetailOption === 0;

    const positionsFn = isCashInBox
      ? livefloorview.getCashInBoxPositions
      : livefloorview.getPerformancePositions;
    const eventsFn = isCashInBox
      ? livefloorview.getCashInBoxEvents
      : livefloorview.getPerformanceEvents;
    const exportsFn = isCashInBox
      ? livefloorview.getCashInBoxPositionsExport
      : livefloorview.getPerformancePositionsExport;
    const eventsExportFn = isCashInBox
      ? livefloorview.getCashInBoxEventsExport
      : livefloorview.getPerformanceEventsExport;

    const modalTitle = isCashInBox
      ? "Cash In Box"
      : "Performance - " + this.state.selectedPeriodText;
    const periodId = this.state.selectedPeriodId;

    this.props.showSiteDetailsModal(
      siteId,
      modalTitle,
      periodId,
      positionsFn,
      eventsFn,
      exportsFn,
      eventsExportFn,
    );
  };

  onExportClick = () => {
    const { filterSelected, filterData } = this.props.filters;
    const { operator, company, subcompany, site } = filterSelected;
    const { selectedDetailOption, selectedPeriodId } = this.state;
    const isCashInBox = selectedDetailOption === 0;
    const exportFn = isCashInBox
      ? livefloorview.getCashInBoxExport
      : livefloorview.getPerformanceExport;

    this.setState({ exportLoading: true }, () => {
      exportFn({
        OperatorId: operator,
        CompanyId: company.id,
        SubCompanyId: subcompany.id,
        SiteId: site.id,
        Manufacturers: prepareFilter(
          filterSelected.manufacturer,
          filterData.manufacturer,
        ),
        GameNames: prepareFilter(filterSelected.game, filterData.game),
        Categories: prepareFilter(
          filterSelected.machinetypes,
          filterData.machinetypes,
        ),
        OperatorRegions: prepareFilter(
          filterSelected.regions,
          filterData.regions,
        ),
        PeriodId: selectedPeriodId,
      }).then(
        (response) =>
          this.setState({ exportLoading: true }, () =>
            handleDownload(response),
          ),
        () => this.setState({ exportLoading: false }),
      );
    });
  };

  onRowClick = (activeRow) => this.setState({ activeRow });

  onPeriodChange = (e, { value }) => {
    const selectedPeriodText = e.nativeEvent.target.textContent;
    this.setState({ selectedPeriodId: value, selectedPeriodText });
  };

  render() {
    const detailOptions = [
      { key: "Cash In Box", value: 0, text: "Cash In Box" },
      { key: "Performance", value: 1, text: "Performance" },
    ];

    const periodOptions = [
      {
        key: "Current Collection Week",
        value: 1,
        text: "Current Collection Week",
      },
      { key: "Week To Date", value: 2, text: "Week To Date" },
      { key: "Month To Date", value: 3, text: "Month To Date" },
    ];

    const disabled = !this.props.filters.hasSelection;
    const { showOrgTree } = this.props.filters;
    const {
      selectedDetailOption,
      loading,
      selectedPeriodId,
      grid,
      activeRow,
      detailsLoading,
    } = this.state;

    return (
      <Grid relaxed className="height-100 gs-flex-container-vertical">
        <Grid.Row>
          <Grid.Column width="12">
            <Form>
              <Form.Group inline>
                <OrgTreeButton
                  active={showOrgTree}
                  onClick={() =>
                    this.props.fetchLiveFloorViewerFilters({
                      showOrgTree: !showOrgTree,
                    })
                  }
                />
                <Form.Field>
                  <Select
                    disabled={disabled}
                    options={detailOptions}
                    value={selectedDetailOption}
                    onChange={(event, { value }) =>
                      this.setState({ selectedDetailOption: value })
                    }
                  />
                </Form.Field>
                {selectedDetailOption === 1 && (
                  <Form.Field>
                    <Select
                      options={periodOptions}
                      value={selectedPeriodId}
                      onChange={this.onPeriodChange}
                    />
                  </Form.Field>
                )}

                <RefreshButton
                  size="medium"
                  disabled={disabled}
                  refresh={() => this.handleRefresh()}
                />

                <div className="ui buttons">
                  <DownloadButton
                    onClick={this.onExportClick}
                    caption="Export"
                    className="ml-0_5"
                    disabled={disabled}
                  />
                </div>
              </Form.Group>
            </Form>
          </Grid.Column>
          <Grid.Column textAlign="right" width="4">
            <DetailsButton
              disabled={!activeRow || loading}
              onClick={this.onDetailsClick}
              loading={detailsLoading}
            />
          </Grid.Column>
        </Grid.Row>
        <Grid.Row className="flex-stretch">
          <Grid.Column className="gs-flex-container-vertical">
            <DataGrid
              loading={loading}
              headings={grid.headerDef}
              rowDef={grid.rowDef}
              data={grid.data}
              groupHeadings={grid.span}
              onRowClick={this.onRowClick}
              fullHeight
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    filters: state.LiveFloorViewerFilters,
  };
};

export default connect(mapStateToProps, {
  fetchLiveFloorViewerFilters,
  showSiteDetailsModal,
})(SiteDetailsTab);
